/*
 * Copyright (C) 2020-2024 The FrontDOOR Corp, Inc. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of The FrontDOOR Corp, Inc.
 * ("Confidential Information").  You shall not disclose such Confidential Information and
 * shall use it only in accordance with the terms of the license agreement you entered into
 * with The FrontDOOR Corp, Inc.
 */

/**
 * Base or common configuration of react grid.
 *
 * @version 1.0 26th Feb 2024
 * @author gbiswajeeta
 */
import { Typography } from "@mui/material";
import { type MRT_RowData, type MRT_TableOptions } from "material-react-table";

export const getDefaultMRTOptions = <TData extends MRT_RowData>(): Partial<
  MRT_TableOptions<TData>
> => ({
  enableHiding: false,
  enableSorting: false,
  enableRowActions: false,
  enableStickyHeader: true,
  enableGlobalFilter: true,
  enableFacetedValues: true,
  enableColumnFilters: true,
  enableRowSelection: false,
  enableDensityToggle: false,
  enableFullScreenToggle: true,
  manualPagination: false,
  muiToolbarAlertBannerProps: { sx: { display: "none" } },
  paginationDisplayMode: "pages",
  muiPaginationProps: {
    color: "primary",
    rowsPerPageOptions: [5, 10, 20, 50, 100],
    variant: "outlined",
    showRowsPerPage: true,
    showFirstButton: true,
    showLastButton: true,
  },
  muiTableBodyRowProps: ({ row }) => ({
    hover: true,
    sx: {
      cursor: "pointer",
      "&.MuiTableRow-root.Mui-selected td": {
        bgcolor: "#ccff90",
        color: "black",
      },
    },
  }),
  initialState: {
    columnVisibility: {},
    density: "compact",
  },
  state: {
    showProgressBars: true,
    sorting: [{ desc: true, id: "createdOn" }],
  },
  renderEmptyRowsFallback: () => (
    <Typography variant="subtitle2" component="p" sx={{ textAlign: "left" }}>
      {"No information available"}
    </Typography>
  ),
  muiTableHeadCellProps: {
    sx: (theme) => ({
      background: theme.palette.primary.main,
      borderRight: "1px solid rgba(224,224,224,1)",
      color: "white",
      ".MuiButtonBase-root": {
        color: "white",
        "&.MuiCheckbox-indeterminate": {
          color: "white",
        },
        "&.Mui-checked": {
          color: "white",
        },
      },
    }),
  },
  muiTableBodyCellProps: {
    sx: {
      borderRight: "1px solid #e0e0e0",
    },
  },
});
